const Resume = () => {
  return <h1>Resumé</h1>
}

export default Resume
